// extracted by mini-css-extract-plugin
module.exports = {"container":"a10a3f92e9--container--TgNzO","body":"a10a3f92e9--body--IblxZ","mortgage":"a10a3f92e9--mortgage--zIy3a"};